<template>
  <sign-page
    title-text="公告管理"
    :request="request"
    table-size="large"
    :column-list="columnList"
    :form-parms-add="formParmsAdd"
    :form-parms-update="formParmsUpdate"
    :table-actions-fixed="true"
    :tableActionsWidth="100"
    :need-data-file="true">
  </sign-page>
</template>

<script>
import {
  placardRequest as request
} from '@/api'

export default {
  computed: {
    formParmsAdd: {
      get () {
        let data = [{
          type: 'input',
          label: '标题',
          key: 'title',
          check: {
            required: true
          }
        },
        {
          type: 'textarea',
          label: '内容',
          key: 'content',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          selectDatas: [{key: '展示', label: '展示'}, {key: '不展示', label: '不展示'}],
          label: '状态',
          key: 'status',
          check: {
            required: true
          }
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          let newItem = {}
          for (let key in item) {
            newItem[key] = item[key]
          }
          data.push(newItem)
        })
        return data
      }
    },
    columnList: {
      get () {
        let data = [{
          title: '标题',
          sort: true,
          field: 'title'
        },
        {
          title: '内容',
          sort: true,
          field: 'content'
        },
        {
          title: '专题',
          sort: true,
          field: 'status'
        }]
        return data
      }
    }
  },
  data () {
    return {
      request: request
    }
  }
}
</script>
